// Display label for an assignable member — shared so the drawer's search index
// and the role/client Select cells always render the same label. Falls back to
// email when the user has no display name (common for invited/pending accounts).
export const getMemberLabel = (member: {
    user: {
        name: string;
        preferredName: string | null;
        email: string | null;
    };
}) => {
    const name = (member.user.preferredName ?? member.user.name).trim();
    if (name) {
        return name;
    }
    return member.user.email ?? "";
};
